import React, {Component} from 'react';
import classnames from 'classnames';
import {Scrollbars} from 'react-custom-scrollbars';

import styles from './RootPage.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

export default class RootPage extends Component {
    render() {
        const {children} = this.props;

        const viewportClasses = classnames(styles.viewport, {[styles.emptyViewport]: !Boolean(children), [styles.homePage]: true});

        return (
            <Scrollbars ref='scrollbars' autoHeight autoHeightMax={'100vh'} className={styles.scroll}>
                <div className={styles.container} id='rootContainer'>
                    <Header homePageOpened {...this.props} />
                    <main className={viewportClasses}>
                        {children ? React.cloneElement(children) : null}
                    </main>
                    <Footer />
                </div>
            </Scrollbars>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layouts/RootPage.js